import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import { PlanDialogProps } from '../types';

export function PlanEditDialog({ open, onClose, onSave, onChange, editingPlan }: PlanDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>
        {editingPlan?.createdAt ? `Modify Plan: ${editingPlan.name}` : 'Forge New Imperial Plan'}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 1 }}>
          <TextField
            fullWidth
            label="Plan ID (unique, lowercase)"
            disabled={!!editingPlan?.createdAt} // Immutable key after creation
            value={editingPlan?.id || ''}
            onChange={(e) => onChange({ ...editingPlan, id: e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, '') })}
            helperText="Permanent identifier. Use snake_case."
          />
          <TextField
            fullWidth
            label="Display Name"
            value={editingPlan?.name || ''}
            onChange={(e) => onChange({ ...editingPlan, name: e.target.value })}
          />
          <TextField
            fullWidth
            label="Brief Description"
            multiline
            rows={2}
            value={editingPlan?.description || ''}
            onChange={(e) => onChange({ ...editingPlan, description: e.target.value })}
          />
          <TextField
            fullWidth
            label="Currency"
            value={editingPlan?.currency || 'usd'}
            onChange={(e) => onChange({ ...editingPlan, currency: e.target.value })}
          />
          <TextField
            fullWidth
            label="Stripe monthly Price ID"
            value={editingPlan?.stripePriceId || ''}
            onChange={(e) => onChange({ ...editingPlan, stripePriceId: e.target.value || undefined })}
          />
          <TextField
            fullWidth
            label="Stripe yearly Price ID"
            value={editingPlan?.stripeYearlyPriceId || ''}
            onChange={(e) => onChange({ ...editingPlan, stripeYearlyPriceId: e.target.value || undefined })}
            helperText="The yearly Stripe amount must equal the monthly amount × 10."
          />
          <TextField
            fullWidth
            type="number"
            label="Display Order"
            value={editingPlan?.displayOrder ?? 0}
            onChange={(e) => onChange({ ...editingPlan, displayOrder: parseInt(e.target.value) || 0 })}
          />
          <TextField
            fullWidth
            type="number"
            label="Max Tokens"
            value={editingPlan?.maxTokens ?? 0}
            onChange={(e) => onChange({ ...editingPlan, maxTokens: parseInt(e.target.value) || 0 })}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={editingPlan?.isActive ?? false}
                onChange={(e) => onChange({ ...editingPlan, isActive: e.target.checked })}
              />
            }
            label="Is Active"
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={() => onSave(editingPlan || {})}
          disabled={!editingPlan?.id || !editingPlan?.name}
        >
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
}
